import { GenericService } from '../generic.service';
import apiClient from '@/services/api/client/apiClient';
import { AxiosResponse } from 'axios';

export class ConsultResolveService extends GenericService<string> {
  async getConsultResolveOptions(): Promise<AxiosResponse<string[]>> {
    return await apiClient.get('v1/consult-resolve-reasons');
  }
}
